// Execute a function and record a 'measure' performance entry with its duration.
export function measure(name, fn) {
    performance.mark(name + ":start");
    const result = fn();
    performance.mark(name + ":end");
    performance.measure(name, name + ":start", name + ":end");
    return result;
}
